/** Shown only when a route takes longer than 400ms to load (router config). */
export function RoutePending() {
  return (
    <div role="status" aria-label="Loading" className="grid min-h-[60dvh] place-items-center">
      <img src="/draper/state-thinking.webp" alt="" className="size-24 opacity-90" />
    </div>
  );
}
